// extracted by mini-css-extract-plugin
export default {"field":"ResetPasswordForm_field__s-6kK","submitBtnContainer":"ResetPasswordForm_submitBtnContainer__CZjHM","submitBtn":"ResetPasswordForm_submitBtn__zm4Ja"};